module.exports = __webpack_public_path__ + "static/media/game_cover_punball@768.d7c42e84.png";